(() => {
  const handle = "seibertron-t-f-f-i-g-2-0-best-tactical-gloves";
  const assetName = "tffig2-tactical-long-finger-size-chart-user-20260728-v1.png";
  const oldAssetName = "tffig-2-0-adult-size-chart-original.jpg";
  const alt = "Seibertron T.F.F.I.G 2.0 tactical long finger adult gloves size chart with hand measurement method";
  const width = 1122;
  const height = 1402;

  function targetPage() {
    return location.pathname.indexOf('/products/' + handle) !== -1;
  }

  function assetUrl() {
    const script = document.currentScript || Array.prototype.slice.call(document.scripts).find((node) => {
      return String(node.src || '').indexOf("tffig-2-0-sizechart-restore-20260716") !== -1 ||
        String(node.src || '').indexOf('tffig-2-0-sizechart-restore-20260716') !== -1;
    });
    if (script && script.src) {
      try { return new URL(assetName + '?v=202607281230', script.src).href; } catch (error) {}
    }
    return '/cdn/shop/t/20/assets/' + assetName + '?v=202607281230';
  }

  function apply() {
    if (!targetPage()) return;
    document.querySelectorAll('img').forEach((img) => {
      const src = String(img.getAttribute('src') || '');
      const text = String(img.getAttribute('alt') || '');
      const isChart = src.indexOf(oldAssetName) !== -1 || src.indexOf(assetName) !== -1 || /T\.F\.F\.I\.G.*size chart/i.test(text);
      if (!isChart) return;
      img.src = assetUrl();
      img.srcset = '';
      img.alt = alt;
      img.width = width;
      img.height = height;
      img.loading = 'lazy';
      img.decoding = 'async';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
  [300, 900, 1800, 3200].forEach((delay) => setTimeout(apply, delay));
})();